import { howItWorks } from "@/mocks/homeData";

export default function HowItWorksSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="como-funciona" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">
            Proceso Simple
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            ¿Cómo funciona?
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            En solo 3 pasos tu espacio estará impecable. Así de fácil.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector Line (desktop) */}
          <div className="hidden md:block absolute top-16 left-1/2 -translate-x-1/2 w-2/3 h-0.5 bg-gradient-to-r from-teal-200 via-emerald-300 to-green-200 z-0"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
            {howItWorks.map((step, idx) => (
              <div key={step.step} className="flex flex-col items-center text-center">
                {/* Step Number Circle */}
                <div className={`w-16 h-16 flex items-center justify-center ${step.color} rounded-2xl mb-6 relative`}>
                  <i className={`${step.icon} text-white text-2xl`}></i>
                  <span className="absolute -top-2 -right-2 w-6 h-6 bg-white border-2 border-gray-100 rounded-full text-xs font-bold text-gray-700 flex items-center justify-center">
                    {idx + 1}
                  </span>
                </div>
                <div className="text-5xl font-black text-gray-100 mb-2 leading-none">{step.step}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-500 leading-relaxed text-sm max-w-xs">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <button
            onClick={scrollToContact}
            className="bg-teal-500 hover:bg-teal-600 text-white font-bold px-10 py-4 rounded-full text-lg transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-arrow-right-line"></i>
            Empieza Ahora — Es Gratis Cotizar
          </button>
        </div>
      </div>
    </section>
  );
}
